import React, { useId, useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
interface FaqItemProps {
  question: string;
  answer: string;
}
export function FaqItem({
  question,
  answer
}: FaqItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  const panelId = useId();
  return <div className="border-b border-brand-charcoal/12" data-id="element-8" data-mp="1r0l9arsfla4b">
      <button type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setIsOpen(current => !current)} className="flex w-full items-center justify-between gap-6 py-5 text-left transition-colors duration-200 ease-out hover:text-brand-charcoal/70 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-charcoal/40" data-id="element-9" data-mp="1qz0f53a13t6z">
        <span className="font-body text-[15px] font-medium leading-snug text-brand-charcoal sm:text-base" data-id="element-10" data-mp="182ipqsink5dw">
          {question}
        </span>
        <span aria-hidden="true" className="flex-none text-brand-charcoal/50" data-id="element-11" data-mp="32g02rllfljuo">
          {isOpen ? <MinusIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-12" data-mp="1024ibu04yat4" /> : <PlusIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-13" data-mp="1001i6h59r1ao" />}
        </span>
      </button>
      {isOpen && <p id={panelId} className="max-w-2xl pb-6 pr-8 text-[15px] leading-relaxed text-brand-charcoal/70" data-id="element-14" data-mp="18ug77bflpq6z">
          {answer}
        </p>}
    </div>;
}